import { Auth, Profile } from '../types/profile';
import api from '../api/axios';
import axios from 'axios';

export const login = async (data: Auth): Promise<Profile> => {
  try {
    const response = await api.post(
      `${import.meta.env.VITE_API_BASE_URL}/auth/login`,
      data
    );

    return response.data;
  } catch (error: any) {
    console.error('Login API error:', error);

    if (axios.isAxiosError(error)) {
      // ✅ Proper backend error extraction
      throw error.response?.data || { message: 'Login failed' };
    }

    throw { message: 'Unexpected error occurred' };
  }
};
export const sendOtp = async (data: {
  email: string;
  captchaToken: string;
  website?: string;
}) => {
  try {
    const response = await api.post(
      `${import.meta.env.VITE_API_BASE_URL}/auth/send-otp`,
      data
    );

    return response.data;
  } catch (error: unknown) {
    if (
      error instanceof Error &&
      'response' in error &&
      error.response &&
      typeof error.response === 'object' &&
      'data' in error.response
    ) {
      console.error('Error sending OTP:', error);
      throw error.response.data;
    }

    console.error('Unexpected error sending OTP:', error);
    throw new Error('An unexpected error occurred while sending OTP');
  }
};

export const verifyOtp = async (data: { email: string; otp: string }) => {
  try {
    const response = await api.post(`${import.meta.env.VITE_API_BASE_URL}/auth/verify-otp`, data);
    return response.data;
  } catch (error: unknown) {
    if (
      error instanceof Error &&
      'response' in error &&
      error.response &&
      typeof error.response === 'object' &&
      'data' in error.response
    ) {
      console.error('Error verify OTP:', error);
      throw error.response.data;
    }
    console.error('Unexpected error verifying OTP:', error);
    throw new Error('An unexpected error occurred while verifying OTP');
  }
};

export const resetPassword = async (data: { token: string; newPassword: string }) => {
  try {
    const response = await api.post(
      `${import.meta.env.VITE_API_BASE_URL}/auth/forgot-password`,
      data
    );
    return response.data;
  } catch (error: unknown) {
    if (
      error instanceof Error &&
      'response' in error &&
      error.response &&
      typeof error.response === 'object' &&
      'data' in error.response
    ) {
      console.error('Error reset Password:', error);
      throw error.response.data;
    }
    console.error('Unexpected error reset Password:', error);
    throw new Error('An unexpected error occurred while reset Password');
  }
};
